import { render, staticRenderFns } from "./DeviceSync2.vue?vue&type=template&id=460cfc43&scoped=true"
import script from "./DeviceSync2.vue?vue&type=script&lang=js"
export * from "./DeviceSync2.vue?vue&type=script&lang=js"
import style0 from "./DeviceSync2.vue?vue&type=style&index=0&id=460cfc43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460cfc43",
  null
  
)

export default component.exports